import { EmployeeDto, EmployeeRequest, getEmptyEmployeeDto } from './userTypes';
import { myAxios } from '../../util/myAxios';
import { Page, Pageable, toUrlParams } from '../../api/pageable';
import { log } from '../../logConfig';
import { isValidationErrorResponse, ValidationErrors } from '../../api/restApi';
import { AxiosResponse } from 'axios';

export function getAccount(): Promise<EmployeeDto> {
  return myAxios()
    .then(axios => axios.get(`/api/v1/account`))
    .then(response => response.data,
      () => getEmptyEmployeeDto()
      );
}

export function getEmployees(
  params: { searchText?: string },
  pageable: Pageable): Promise<Page<EmployeeDto>> {
  const searchParam = params.searchText === undefined ? '' : `search=${encodeURIComponent(params.searchText)}&`;

  return myAxios()
    .then(axios => axios.get(`/api/v1/employees?${searchParam}` + toUrlParams(pageable)))
    .then(response => response.data, reason => log.info('nö' + reason.response.status));
}

export function createEmployee(employee: EmployeeRequest): Promise<EmployeeDto | ValidationErrors> {
  return myAxios()
    .then(axios => axios.post('/api/v1/employees', employee))
    .then(
      response => response.data,
      error => {
        const response: AxiosResponse = error.response;
        if (isValidationErrorResponse(response)) {
          return response.data;
        } else {
          throw error;
        }
      }
    );
}

export function updateEmployee(employee: EmployeeDto): Promise<EmployeeDto | ValidationErrors> {
  return myAxios()
    .then(axios => axios.put('/api/v1/employees/' + employee.id, employee))
    .then(response => response.data,
      error => {
        const response: AxiosResponse = error.response;
        if (isValidationErrorResponse(response)) {
          return response.data;
        } else {
          throw error;
        }
      }
    );
}
